/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Label, HasPermission, Icon, Row } from "@fitinsur/components";

export default function userColumns({
  history,
  setDialogConfirmation,
  setModalConfirmationDetails,
  getDescription,
  setSelectedUser,
  setIsRestore,
  permissions,
  idPerson
}) {
  return [
    {
      title: getDescription("DOMAINS", 829),
      value: "fullName",
      key: "fullName",
      minWidth: 10,
      maxWidth: 10,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return (
          <Label wordWrap fontSize={14}>
            {`${listItem.personFirstName} ${listItem.personLastName}`}
          </Label>
        )
      }
    },
    {
      title: getDescription("DOMAINS", 828),
      value: "user",
      key: "user",
			minWidth: 10,
			maxWidth: 10,
			component: (listItem) => {
        return (
          <Label wordWrap fontSize={14}>
           {listItem?.user ? listItem.user[0]?.userName : '-'}
          </Label>
        )
      }
		},
    {
      title: getDescription("DOMAINS", 830),
      value: "status",
      key: "status",
      minWidth: 10,
      maxWidth: 20,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return (
          <Label wordWrap fontSize={14}>
            {listItem.personGDPRRelationshipExpireDate ? "Inativo" : "Ativo"}
          </Label>
        )
      }
    },
    {
      title: getDescription("DOMAINS", 827),
      key: "action",
      minWidth: 10,
      maxWidth: 10,
      paddingRight: 5,
      component: (listItem) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', flexDirection: 'column' }}>
            <Row className="align-items-center justify-content-start" style={{ width: 75 }}>
            <HasPermission permission={listItem.idPerson != idPerson}>
                <Icon
                  name="edit"
                  title={getDescription("DOMAINS", 805)}
                  onClick={() => {
                    history.push(`/management/58/person/edit/${listItem.idPerson}`);
                    window.location.reload();
                  }}
                />
              </HasPermission>
              <HasPermission permission={permissions.EDIT_USER && listItem.user && listItem.user?.length}>
                <Icon
                  name="edit-user"
                  title={getDescription("DOMAINS", 854)}
                  onClick={() => {
                    history.push(`/management/58/user/edit/${listItem.idPerson}/${listItem.user[0]?.idUser}`);
                    window.location.reload();
                  }}
                />
              </HasPermission>
              {
                !listItem.personGDPRRelationshipExpireDate
                  ? <Icon
                    name="disable-user"
                    title={getDescription("DOMAINS", 866)}
                    disabled={!listItem?.user}
                    onClick={() => {
                      setSelectedUser(listItem);
                      setIsRestore(false);
                      setDialogConfirmation({ visible: true });
                      setModalConfirmationDetails({
                        text: getDescription("DOMAINS", 989),
                        textButtonConfirm: getDescription("DOMAINS", 815),
                        textButtonCancel: getDescription("DOMAINS", 816),
                        type: "user"
                      });
                    }}
                  />
                  : <Icon
                    name="restaure-user"
                    title={getDescription("DOMAINS", 867)}
                    disabled={!listItem?.user}
                    onClick={() => {
                      setSelectedUser(listItem);
                      setIsRestore(true);
                      setDialogConfirmation({ visible: true });
                      setModalConfirmationDetails({
                        text: getDescription("DOMAINS", 991),
                        textButtonConfirm: getDescription("DOMAINS", 815),
                        textButtonCancel: getDescription("DOMAINS", 816),
                        type: "user"
                      });
                    }}
                  />
              }
            </Row>
          </div>
        )
      }
    }
  ];
}
